import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function ItemType ( props ) {

    return <BasicCrudScreenType id="ItemType" table="ItemType" view="VwItemType" />;

}

export default ItemType;
